/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import { parseUrl } from "query-string";
import PropTypes from "prop-types";
import { Logo } from "../../molecules/publisher-logo";
import { User } from "../user";
import { NavigationLinks } from "../navigation-link";
import { SubscriptionStatusBtn } from "../../molecules/subscription-status-btn";
import { IS_OPEN_LOGIN_FORM } from "../../helper/actions";
import "./navigation.m.css";
import { getGlobalPlayerRef } from "../../podcast-player/utils";
import SearchIcon from "../../atoms/icons/search-icon";
import debounce from "lodash.debounce";

class NavigationBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOffcanvasMenu: false,
      showPlayer: false,
      loadingUserQueue: false,
      playerState: {},
      scrollDirection: null,
      location: ""
    };
    this.toggleOffcanvasMenu = this.toggleOffcanvasMenu.bind(this);
    this.closeOffcanvasMenu = this.closeOffcanvasMenu.bind(this);
    this.handleNavigation = debounce(this.handleNavigation, 10, {
      leading: true
    });
  }

  handleNavigation = () => {
    // Bounce scroll on iOS
    if (window.scrollY < 0) {
      return;
    }

    if (this.prev > window.scrollY) {
      this.navElement && this.navElement.classList.remove("nav-hide");
    } else if (this.prev < window.scrollY) {
      this.navElement && this.navElement.classList.add("nav-hide");
    }
    this.prev = window.scrollY;
  };

  componentDidMount() {
    this.setState({ location: global.location.host });
    const playerRef = getGlobalPlayerRef();
    this.removePlayerListener = playerRef.addPlayerListener(state => {
      this.setState({
        showPlayer:
          (state.showPlayer && state.currentTrackId) || !!state.currentScreen,
        loadingUserQueue: state.loadingUserQueue,
        playerState: state
      });
    });

    this.prev = window.scrollY;
    window.addEventListener("scroll", this.handleNavigation);
  }

  componentWillUnmount() {
    this.removePlayerListener();
    window.removeEventListener("scroll", this.handleNavigation);
  }

  async getSubscription() {
    const playerRef = getGlobalPlayerRef();
    if (!this.props.member) {
      // await this.props.manageLoginForm(true);
      playerRef.userClickedMicIcon = true;
      const params = parseUrl(this.props.currentPath);
      const callbackUrl = get(
        params,
        ["query", "callback-url"],
        global.location && global.location.origin
      );
      const redirectUrl = get(
        params,
        ["query", "redirect-url"],
        global && global.location && global.location.href
      );
      window.location = `${this.props.authHost}/authenticate?redirect-url=${redirectUrl}&callback-url=${callbackUrl}&auth-page=${this.props.authHost}/user-login`;
      playerRef.userClickedMicIcon = true;
    } else {
      // If track is playing show bottom player else show library screen
      if (this.state.playerState.currentTrackId) {
        playerRef.togglePlayer();
      } else {
        playerRef.setCurrentScreen("library");
      }
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    !newProps.showOffcanvasMenu && this.closeOffcanvasMenu();
  }

  toggleOffcanvasMenu() {
    this.setState(prevState => {
      return {
        showOffcanvasMenu: !prevState.showOffcanvasMenu
      };
    });
  }

  closeOffcanvasMenu() {
    this.setState({
      showOffcanvasMenu: false
    });
    const playerRef = getGlobalPlayerRef();
    playerRef.setShowMenu(false);
  }

  pushToDataLayer(event, title) {
    const obj = {
      event: event,
      subscription_category: title,
      usertype: this.props.member ? "logged in" : "logged out",
      subscribertype: this.props.fetchSubscription
        ? this.props.fetchSubscription.isActive
          ? "subscriber"
          : "nonsubscriber"
        : "nonsubscriber",
      userID: this.props.member ? this.props.member.id : "null",
      subscriptionID: this.props.fetchSubscription
        ? this.props.fetchSubscription.items.find(sub => sub.active === true).id
        : "null"
    };

    window.dataLayer.push(obj);
  }

  render() {
    return (
      <div
        styleName="navigation"
        className="navigation"
        ref={navElement => (this.navElement = navElement)}
      >
        <div styleName="navigation-top">
          <div className="container" styleName="navigation-top-container">
            <div styleName="navigation-hamburger-button">
              {/*  <HamburgerMenu onClick={this.toggleOffcanvasMenu} /> */}
            </div>
            <div styleName="navigation-logo">
              <Link href="/">
                <Logo />
              </Link>
            </div>
            <div styleName="navigation-icons">
              <div styleName="social-share-icons">
                {/* <SocialIcons socialLinks={this.props.socialLinks} /> */}
              </div>
              <div styleName="podcast-subscription-wrapper">
                <Link href="/newsletter-signup?ref=nav">
                  <button
                    styleName="podcast-icon default-color"
                    onClick={() =>
                      this.pushToDataLayer(
                        "nl_top_navigation",
                        "newsletter_subscription"
                      )
                    }
                    aria-label="newsletters"
                  >
                    <img
                      src="https://img.icons8.com/material-outlined/96/ffffff/email-open.png"
                      width="33"
                      height="25"
                    />
                  </button>
                </Link>
                <SearchIconButton />
                &nbsp; &nbsp; &nbsp;
                <div styleName="navigation-buttons">
                  <SubscriptionStatusBtn />
                </div>
              </div>
              <div styleName="user-icons">
                {/* <Search /> */}
                <User />
              </div>
            </div>
          </div>
        </div>
        <div
          className="navigation-bottom"
          style={{
            display:
              (this.props.storyTemplate === "live-qa" ||
                this.props.currentPath.includes("/subscription") ||
                this.props.currentPath.includes("/gift") ||
                this.props.currentPath.includes("/campaign/checkout")) &&
              "none"
          }}
        >
          <div
            className="container"
            style={{ display: "flex", alignItems: "center" }}
          >
            <li
              styleName="item"
              className="desktop-mini-logo"
              style={{ padding: 0, alignSelf: "flex-end" }}
            >
              <Link href={"/"} style={{ lineHeight: 0 }}>
                <img
                  style={{ height: "3rem" }}
                  src="https://images.assettype.com/newslaundry/2020-10/fe2dc714-ad63-43b8-a43f-999fd1f9c7bc/qiMQgIos_400x400.png"
                  alt="logo"
                ></img>
              </Link>
            </li>
            <NavigationLinks
              links={this.props.menu}
              showOffcanvasMenu={this.state.showOffcanvasMenu}
              closeMenu={this.closeOffcanvasMenu}
              domainSlug={this.props.domainSlug}
            />
          </div>
        </div>
      </div>
    );
  }
}

NavigationBase.propTypes = {
  socialLinks: PropTypes.object,
  menu: PropTypes.array,
  member: PropTypes.object,
  manageLoginForm: PropTypes.func,
  memberLoading: PropTypes.bool,
  authHost: PropTypes.string,
  currentPath: PropTypes.string,
  domainSlug: PropTypes.string
};

const mapDispatchToProps = dispatch => ({
  manageLoginForm: function(payload) {
    dispatch({
      type: IS_OPEN_LOGIN_FORM,
      payload: payload
    });
  }
});

function mapStateToProps(state) {
  const menu =
    get(state, ["qt", "data", "navigationMenu", "headerLinks"], []) ||
    get(state, ["qt", "data", "navigationMenu", "default"], []);
  return {
    title: "Newslaundry",
    menu: menu,
    socialLinks: get(state, ["qt", "config", "social-links"], []),
    showOffcanvasMenu: state.offcanvasMenu,
    member: get(state, ["member"], null),
    memberLoading: state.memberLoading,
    currentPath: get(state, ["qt", "currentPath"], ""),
    storyTemplate: get(state, ["qt", "data", "story", "story-template"], null),
    authHost: get(
      state,
      ["qt", "config", "publisher", "publisher", "auth_host"],
      null
    ),
    domainSlug: get(state, ["qt", "domainSlug"], null),
    subscription: get(state, ["fetchSubscription"], {})
  };
}

function SearchIconButton() {
  return (
    <div styleName="search-stories-component">
      <Link href={"/search"}>
        <SearchIcon className="search-stories-component-icon" height={20} />
      </Link>
    </div>
  );
}

export const NavBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationBase);
